"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _box = _interopRequireDefault(require("@waglabs/box"));

var _icon = _interopRequireDefault(require("@waglabs/icon"));

var _TextInput = _interopRequireDefault(require("../TextInput"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var StyledTextInput =
/*#__PURE__*/
function (_react$Component) {
  _inheritsLoose(StyledTextInput, _react$Component);

  function StyledTextInput() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _react$Component.call.apply(_react$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      displayPassword: false
    });

    _defineProperty(_assertThisInitialized(_this), "getPaddingRight", function () {
      var _this$props = _this.props,
          isValid = _this$props.isValid,
          touched = _this$props.touched,
          type = _this$props.type;

      if (type === 'password') {
        if (isValid && touched) {
          return '65px';
        }
      }

      if (isValid && touched) {
        return '35px';
      }

      return '10px';
    });

    _defineProperty(_assertThisInitialized(_this), "getType", function () {
      var type = _this.props.type;
      var displayPassword = _this.state.displayPassword;

      if (type === 'password' && displayPassword) {
        return 'text';
      }

      return type;
    });

    _defineProperty(_assertThisInitialized(_this), "togglePassword", function () {
      return _this.setState(function (_ref) {
        var displayPassword = _ref.displayPassword;
        return {
          displayPassword: !displayPassword
        };
      });
    });

    return _this;
  }

  var _proto = StyledTextInput.prototype;

  _proto.render = function render() {
    var _this$props2 = this.props,
        value = _this$props2.value,
        type = _this$props2.type,
        isValid = _this$props2.isValid,
        touched = _this$props2.touched,
        onRef = _this$props2.onRef,
        validFieldIconName = _this$props2.validFieldIconName,
        props = _objectWithoutPropertiesLoose(_this$props2, ["value", "type", "isValid", "touched", "onRef", "validFieldIconName"]);

    return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_TextInput.default, _extends({
      height: 50,
      width: 1,
      fontSize: 4,
      fontFamily: "body",
      boxShadow: "none",
      borderRadius: 3,
      color: "medGray",
      pb: 0,
      px: 2,
      pr: this.getPaddingRight,
      textIndent: "10px",
      type: this.getType(),
      value: value
    }, props)), type === 'password' && _react.default.createElement(_box.default, {
      position: "absolute",
      width: "20px",
      height: "20px",
      top: "17px",
      cursor: "pointer",
      right: touched && isValid ? '45px' : '15px'
    }, _react.default.createElement(_icon.default, {
      width: "20px",
      height: "20px",
      onClick: this.togglePassword,
      name: "eyeball"
    })), touched && isValid && _react.default.createElement(_box.default, {
      position: "absolute",
      width: "25px",
      height: "25px",
      top: "13px",
      right: "10px"
    }, _react.default.createElement(_icon.default, {
      width: "25px",
      height: "25px",
      name: validFieldIconName
    })));
  };

  return StyledTextInput;
}(_react.Component);

_defineProperty(StyledTextInput, "defaultProps", {
  isValid: true,
  validFieldIconName: 'checkmark'
});

var _default = StyledTextInput;
exports.default = _default;